import React, { useState, useEffect } from "react";
import arrow from '../assets/images/arrow-down.png'
import { Form, Button } from 'react-bootstrap'
import './filter.css'

import c from '../assets/data/colors'

const dict = {
  TransportationUnits: 'TU',
  RouteNode: 'RN',
  RouteEdge: 'RE',
  StationSchema: 'SS'
};

const Filter = ({ infoWord, verticalorder, objects, levels, units, setUnits, setLevels, downloadStations }) => {

  const manageLevels = (object) => {
    if (levels.includes(object)) {
      setLevels(levels.filter(item => item !== object)
      )
    } else {
      setLevels([...levels, object])
    }
  }

  const manageUnits = (object) => {
    if (units.includes(object)) {
      setUnits(units.filter(item => item !== object)
      )
    } else {
      setUnits([...units, object])
    }
  }

  const [show, setShow] = useState(false);
  const [init, setInit] = useState(false);

  useEffect(() => {
    if (objects && !init) {
      manageUnits("RouteEdge")
      setInit(true);
    }
  }, [objects])

  return <>
    <div id="info" className="info" style={{ ...normalInfo, display: (show ? 'block' : 'none') }} >
      <form style={{ paddingLeft: '55px', paddingTop: '10px', paddingRight: '10px', paddingBottom: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
        <Form.Group className={'formGroup'}>
          <Form.Label className={'customHeader'}>VertO:</Form.Label>
          {
            units.length > 0 && verticalorder.map((object) =>
              <Form.Check bsPrefix={'customForm'} style={bigCheckbox} key={object} id={object} label={object} onChange={() => manageLevels(object)} />
            )
          }
        </Form.Group>
        <Form.Group className={'formGroup'}>
          <Form.Label className="customHeader">Obj:</Form.Label>
          {
            objects && objects.map((object) =>
              <Form.Check bsPrefix={'customForm'} style={bigCheckbox} id={object} label={dict[object]} defaultChecked={(object === 'RouteEdge' ? "true" : undefined)} onChange={() => manageUnits(object)} />
            )
          }
        </Form.Group>
      </form>
      <Button variant="success" type="submit" onClick={() => setShow(false)}>Ukryj</Button>
    </div>
    <div style={{ transform: 'rotate(90deg)', zIndex: 1000, top: 160, right: -142, position: 'absolute', display: (show ? 'none' : 'flex'), flexDirection: 'row', justifyContent: 'flex-end' }}>
      <Button variant="success" type="submit" style={{ margin: 5 }} onClick={() => setShow(true)}>Warstwy</Button>
      <Button variant="warning" type="submit" style={{ margin: 5 }} onClick={() => downloadStations()}>Odśwież</Button>
      <Button variant="danger" type="submit" style={{ margin: 5 }} onClick={() => window.location.reload()}>Wybór stacji</Button>
    </div>
  </>
}

const InfoGame = ({ infoWord, style }) => {

  let infoStyle = null;

  if (style === "right") { infoStyle = { ...normalInfo, color: c.green } }
  else if (style === "wrong") { infoStyle = { ...normalInfo, color: c.red } }
  else { infoStyle = { ...normalInfo, color: c.naviblue } }

  return (
    <div id="info" className="info" style={infoStyle}>
      {infoWord}
    </div>
  );
}

const InfoExtended = ({ object }) => {

  const [detailsKeys, setDetailsKeys] = useState([])

  useEffect(() => {
    let obj = Object.assign({}, object);
    ['name', 'id', 'lvlDiff'].forEach(e => {
      delete obj[e]
    })
    let attributes = Object.keys(obj)
    attributes.forEach((part, index, theArray) => {
      theArray[index] = [object.id, part]
    })
    setDetailsKeys(attributes)
  }, [object])

  return (
    <div id="infoExtended" className="info" style={infoStyle}>
      {detailsKeys.map(e => {
        return (
          <div key={e[1]}>{object[e[1]]}</div>
        )
      })}
    </div>
  );
}

export { Filter, InfoGame, InfoExtended }


const infoStyle = {
  ...c.whitebox,
  'marginTop': 15,
  'zIndex': 1000,
  ...c.cambayregular,
  'color': c.naviblue,
}

const normalInfo = {
  ...c.whitebox,
  'position': 'absolute',
  'right': 0,
  height: '260px',
  'margin': 15,
  'width': '50%',
  maxWidth: '325px',
  'paddingLeft': 0,
  'paddingBottom': 0,
  'paddingTop': 0,
  'paddingRight': 0,
  'zIndex': 1000,
  ...c.cambaybold,
}

const bigCheckbox = {
  width: '36px',
  height: '36px',
  fontSize: '20px'
}